export default __webpack_public_path__ + "static/media/mastercard-logo.6fd61870.png";